import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Horse_show } from '../models/horse_show';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class HorseShowService {

  constructor(private http: HttpClient) {
  }

  get(id: string): Promise<Horse_show> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'horse_shows/id/' + id).subscribe((response:any) => {
			if(response.type == 'horse_show' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error_response => {
	      		if(error_response instanceof HttpErrorResponse){
	      			reject(error_response.error);
	      		}
	      		reject(error_response);
			});
	});
  }

  getLive(): Promise<Horse_show[]> {
  	return this.getListWithRest('live/true');
  }

  getLiveByCountry(country_code: string): Promise<Horse_show[]> {
  	return this.getListWithRest('live/true/country/' + country_code);
  }

  getLiveByFederation(country_code: string, federation_code: string): Promise<Horse_show[]> {
  	return this.getListWithRest('live/true/country/' + country_code + "/federation/" + federation_code);
  }

  getListWhereEntryAvailable(country_code: string): Promise<Horse_show[]> {
  	return this.getListWithRest('entry_available/true/country/' + country_code);
  }


  getListWhereSignupAvailable(country_code: string): Promise<Horse_show[]> {
  	return this.getListWithRest('sign_up_available/true/country/' + country_code);
  }

  getListWhereDeclarationAvailable(country_code: string): Promise<Horse_show[]> {
  	return this.getListWithRest('declaration_available/true/country/' + country_code);
  }

  private getListWithRest(rest_url: string) : Promise<Horse_show[]> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'horse_shows/' + rest_url).subscribe((response:any) => {
			if(response.type == 'horse_shows' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error_response => {
	      		if(error_response instanceof HttpErrorResponse){
	      			reject(error_response.error);
	      		}
	      		reject(error_response);
			});
	});
  }

}
